<template>
  <div>
    <v-row align="center" class="px-12">
      <v-col style="max-width: fit-content">
        <v-icon right @click="changePage">mdi-arrow-left</v-icon>
      </v-col>
      <v-col style="max-width: fit-content">
        <h4
          style="
            margin-left: 0px;
            font-size: 28px;
            color: #777;
            font-weight: 300;
            text-align: left;
            min-inline-size: max-content;
          "
        >
          {{ standActions.name }}
        </h4>
      </v-col>
      <v-col offset-xs="3" offset-sm="7" offset-md="7">
        <!-- <v-btn icon color="admiraFontGray" class="py-0 my-0" style="margin-left:-55px;">
              <v-icon style="cursor: pointer; font-size:25px" @click="infoStand">mdi-information-variant</v-icon>
          </v-btn>   -->
      </v-col>
    </v-row>

    <v-divider />

    <v-row align="center" style="padding-left: 0px !important">
      <v-col cols="8" style="border-right: 1px solid lightgrey">
        <v-row>
          <v-col>
            <p
              style="
                padding-left: 30px;
                font-size: 28px;
                color: #777;
                font-weight: 300;
                float: left;
                margin-bottom: 0;
              "
            >
              Turno Actual
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div v-if="editedQueue.type == 3">
              <div style="display: flex; margin-left: 25px">
                <div style="display: inline">
                  <v-icon style="font-size: 55px"
                    >mdi-ticket-confirmation</v-icon
                  >
                </div>
                <div>
                  <p
                    style="
                      text-align: left;
                      margin-left: 25px;
                      font-size: 22px;
                      color: #777;
                      font-weight: 300;
                    "
                  >
                    {{ editedQueue.name }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="editedQueue.type == 2">
              <div style="display: flex; margin-left: 25px">
                <div>
                  <v-icon style="font-size: 55px">mdi-ticket-outline</v-icon>
                </div>
                <p
                  style="
                    text-align: left;
                    margin-left: 25px;
                    font-size: 22px;
                    color: #777;
                    font-weight: 300;
                  "
                >
                  {{ editedQueue.name }}
                </p>
              </div>
            </div>
            <div v-if="editedQueue.type == 1">
              <div style="display: flex; margin-left: 25px">
                <div>
                  <v-icon style="font-size: 55px">mdi-human-male-male</v-icon>
                </div>
                <p
                  style="
                    text-align: left;
                    margin-left: 25px;
                    font-size: 22px;
                    color: #777;
                    font-weight: 300;
                  "
                >
                  {{ editedQueue.name }}
                </p>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <!-- <v-col>
                <p style="padding-left: 30px; font-size:28px; color:#777; font-weight:300; float: left; margin-bottom: 0;">Turno </p>
              </v-col> -->
          <!-- <v-col v-if="editedQueue.type == 3">
                  <p style="font-size:28px; color:#777; font-weight:300;">Pendientes </p>
              </v-col> -->
        </v-row>

        <v-row>
          <v-col style="padding-left: 30px; padding-right: 30px">
            <v-container
              style="
                background-color: #eeee;
                border-radius: 15px;
                height: 200px;
              "
            >
              <!-- <p
                style="
                  color: #acacac;
                  margin-bottom: 0px;
                  font-size: 90px;
                  font-weight: 300;
                  margin-top: 15px;
                "
                v-if="actualTicket.length == 0"
              >
                --
              </p>

              <p
                style="
                  color: #acacac;
                  margin-bottom: 0px;
                  font-size: 90px;
                  font-weight: 300;
                  margin-top: 15px;
                "
                v-if="actualTicket == null"
              >
                --
              </p>
              <p
                style="
                  color: #acacac;
                  margin-bottom: 0px;
                  font-size: 90px;
                  font-weight: 300;
                  margin-top: 15px;
                "
                v-if="actualTicket != null"
              >
                {{ actualTicket.ticket }}
              </p> -->
              <!-- <!-- <p style=" color:#acacac; margin-bottom: 0px; font-size: 90px; font-weight: 300; margin-top: 15px;" v-if="tiquetQueue.ticketNow != null">{{tiquetNumber}}</p> -->
              <p style=" color:#acacac; margin-bottom: 0px; font-size: 90px; font-weight: 300; margin-top: 15px;" >{{tiquetNumber}}</p>
              <!-- <p style=" color:#acacac; margin-bottom: 0px; font-size: 90px; font-weight: 300; margin-top: 15px;" v-if=" actualTicket != null">{{actualTicket.ticket}}</p> -->
            </v-container>
          </v-col>
          <v-col v-if="editedQueue.type == 3"> </v-col>
        </v-row>

        <v-row>
          <v-row v-if="editedQueue.type == 1">
            <v-col>
              <v-btn
                @click="createTicket"
                color="#679940"
                width="84%"
                height="230%"
                dark
                depressed
                x-large
                min-width="100"
                >Nuevo</v-btn
              >
            </v-col>
          </v-row>

          <v-row v-if="editedQueue.type == 2">
            <v-col>
              <v-btn
                @click="deleteTicket"
                color="#acacac"
                dark
                depressed
                x-large
                width="43%"
                min-width="100"
                ><v-icon>mdi-skip-previous</v-icon>Anterior</v-btn
              >
              <v-btn
                @click="createTicket"
                color="#679940"
                dark
                depressed
                x-large
                width="43%"
                min-width="100"
                ><v-icon>mdi-skip-next</v-icon>Siguiente</v-btn
              >
            </v-col>
          </v-row>

          <v-row v-if="editedQueue.type == 3">
            <v-col>
              <v-row
                v-if="showCreate == true && showbutton"
                style="margin-left: 33px; margin-bottom: 8px"
              >
                <v-btn
                  @click="assignTicket"
                  color="#679940"
                  dark
                  depressed
                  small
                  min-width="100"
                  width="95%"
                  >asignar</v-btn
                >
              </v-row>
              <v-row
                v-if=" showbutton == false"
                style="margin-left: 33px; margin-bottom: 8px"
              >
                <v-btn
                  @click="closeTicket"
                  color="#ebab34"
                  dark
                  depressed
                  small
                  min-width="100"
                  width="95%"
                  >Cerrar</v-btn
                >
              </v-row>
              <v-row
                v-if=" showbutton == false"
                style="margin-left: 33px; margin-bottom: 8px"
              >
                <v-btn
                  @click="closeAndNextTicket"
                  color="#acacac"
                  dark
                  depressed
                  small
                  min-width="100"
                  width="95%"
                  ><v-icon>mdi-close-circle-outline</v-icon
                  ><v-icon>mdi-menu-right</v-icon>Cerrar y siguiente</v-btn
                >
              </v-row>
              <v-row
                v-if=" showbutton == false"
                style="margin-left: 33px; margin-bottom: 8px"
              >
                <v-btn
                  @click="cancelAndNextTicket"
                  color="#acacac"
                  dark
                  depressed
                  small
                  min-width="100"
                  width="95%"
                  ><v-icon>mdi-cancel</v-icon
                  ><v-icon>mdi-menu-right</v-icon>Cancelar y siguiente</v-btn
                >
              </v-row>
            </v-col>

            <v-col>
              <!-- <v-row> -->
              <!-- <v-row v-for="tiquets in arrTiquets" :key="tiquets.resources">
                        <v-col style="background-color: #eeee; border-radius: 15px; height: 60px; width:100px; margin-left: 35px; ">
                          <p style=" color:#acacac; margin-bottom: 0px; font-size: 30px; font-weight: 300; " v-if="tiquets.ticketNow != null">{{tiquets.ticketNow.ticket}}</p>
                        </v-col>
                      </v-row> -->
            </v-col>
          </v-row>
        </v-row>
      </v-col>

      <!-- <v-col class="pt-0" cols="8">
        <v-row style="border-bottom: 1px solid lightgrey">
          <v-col style="color: #777" cols="7">
            <p>Colas Activas</p>
          </v-col>
          <v-col style="color: #777" cols="2">
            <p>Tipo</p>
          </v-col>
          <!-- <v-col style="color:#777;" cols="3">
              <p>Pendientes</p>
            </v-col> -->
          <!-- <v-col style="color: #777" cols="3"> </v-col>
        </v-row>

        <v-row style="max-height: calc(100vh - 203px); overflow: auto">
          <v-col cols="12">
            <v-row v-for="queue in tiquets" :key="queue.queue">
              <v-col
                cols="2"
                style="
                  border-right: 1px solid lightgrey;
                  border-bottom: 1px solid lightgrey;
                "
              >
                <v-switch
                  v-model="queue.switch"
                  @change="closeTicketSwitch(queue)"
                  label="Estado"
                ></v-switch>
              </v-col>
              <v-col cols="5">
                <v-icon
                  v-if="queue.typeQueue == 1"
                  color="admiraFontGray"
                  style="float: left; margin-left: 10%; margin-top: 10%"
                  >mdi-human-male-male</v-icon
                >
                <v-icon
                  v-if="queue.typeQueue == 2"
                  color="admiraFontGray"
                  style="float: left; margin-left: 10%; margin-top: 10%"
                  >mdi-ticket-outline</v-icon
                >
                <v-icon
                  v-if="queue.typeQueue == 3"
                  color="admiraFontGray"
                  style="float: left; margin-left: 10%; margin-top: 10%"
                  >mdi-ticket-confirmation</v-icon
                >
                <p
                  style="
                    display: -webkit-inline-box;
                    float: left;
                    margin-left: 10%;
                    margin-top: 10%;
                  "
                >
                  {{ queue.nameQueue }}
                </p>
              </v-col>
              <v-col cols="2">
                <p
                  style="margin-left: 10%; margin-top: 10%"
                  v-if="queue.typeQueue == 1"
                >
                  Fila
                </p>
                <p
                  style="margin-left: 10%; margin-top: 10%"
                  v-if="queue.typeQueue == 2"
                >
                  Tiquets
                </p>
                <p
                  style="margin-left: 10%; margin-top: 10%"
                  v-if="queue.typeQueue == 3"
                >
                  Multipuesto
                </p>
              </v-col> -->
              <!-- <v-col cols="3">
              <p>Pendientes</p>
            </v-col> -->
<!-- 
              <v-col cols="3">
                <v-btn
                  v-if="showbutton"
                  @click="assignTicketLeft(queue)"
                  color="#679940"
                  dark
                  rounded
                  depressed
                  small
                  >asignar</v-btn
                >

                <v-btn
                  @click="restartQueueLeft(queue)"
                  color="#acacac"
                  dark
                  rounded
                  depressed
                  centered
                  small
                  min-width="50"
                  ><v-icon>mdi-reload</v-icon>RESETEAR</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col> --> 
    </v-row>
    <v-navigation-drawer
      hide-overlay
      :disable-route-watcher="true"
      :value="showRightMenu"
      absolute
      :clipped="$vuetify.breakpoint.smAndUp"
      width="419"
      style="height: calc(100vh - 50px); z-index: 100"
      class="elevation-4"
      right
      stateless
    >
      <RightMenuStandDetail v-if="RightMenuStandDetail" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import axios from "axios";
import router from "vue-router";
import RightMenuStandDetail from "@/components/RightMenuStandDetail.vue";

export default {
  name: "queues",
  components: {
    RightMenuStandDetail,
  },
  data: () => ({
    showCreate: true,
    switch1: true,
    tiquetQueue: null,
    components: {},
    deleteDialog: false,
  }),
  computed: {
    tiquets() {
      let tiquets = this.TiquetFirst;
      tiquets.forEach((element) => {
        element.switch = true;
      });
      return tiquets;
    },

    showbutton() {
      let show = true;
      this.TiquetFirst.forEach((element) => {
        if (element.ticketNow != null) {
          show = false;
        }
      });
      return show;
    },
    tiquetNumber(){
    console.log(this.TiquetFirst);
    console.log(this.editedQueue);
    console.log(this.actualTicket);


    this.TiquetFirst.forEach((element) => {
      if (element.queue == this.editedQueue.idQueue) {
        this.tiquetQueue = element;
      }
      
    });
    console.log(this.tiquetQueue);
    if(this.tiquetQueue != null){
    if(this.tiquetQueue.ticketNow == null){
        return "--"
    }else{
        return this.tiquetQueue.ticketNow.ticket
              this.showCreate = false
    }
    }else{
      return "---"
    }
    },
    // arrQueues(){
    //   let idResource = this.standActions.idResource
    //   let arstands = this.allQueues
    //   let variable = arstands.filter(stand => stand.resources.includes(idResource))
    //   return variable
    // },
    ...mapState("queues", [
      "actualTicket",
      "RightMenuStandDetail",
      "showRightMenu",
      "TiquetFirst",
      "Tiquet",
      "standActions",
      "allQueues",
      "editedQueue",
      "allResouces",
    ]),
    headers() {
      return [];
    },
  },
  methods: {
    ...mapActions("queues", [
      "assignTicketStoreLeft",
      "rightMenuTrueNewDeviceTableStore4",
      "closeTicketStore",
      "getTicketStore",
      "restartQueueStore",
      "deleteTicketStore",
      "createTicketStore",
      "assignTicketStore",
      "cancelnextStore",
      "closeNextStore",
    ]),
    ...mapMutations("queues", [
      "openRightMenuMutation",
      "closeRightMenuMutation",
    ]),

    changePage() {
      this.actualTicket = [];
      this.$router.go(-1);
      this.closeRightMenuMutation();
      this.tiquetQueue = null;
    },

    infoStand() {
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore4();
    },

    async createTicket() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      await this.createTicketStore(ids);
      await this.getTicketStore(this.standActions.idResource);

    },

    async deleteTicket() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      await this.deleteTicketStore(ids);
      await this.getTicketStore(this.standActions.idResource);

    },
    async closeTicketSwitch(queue) {
      if (queue.switch == false) {
        let ids = [queue.queue, this.standActions.idResource];
        this.closeTicketStore(ids);
        // this.showCreate =true;
      }
    },
    async restartQueue() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      this.restartQueueStore(ids);
    },
    async assignTicket() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      await this.assignTicketStore(ids);
      console.log(this.actualTicket);

      if (this.actualTicket.length != 0) {
        this.showCreate = false;
      }
      this.getTicketStore(this.standActions.idResource);
    },
    async closeTicket() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      await this.closeTicketStore(ids);
      console.log(this.actualTicket)
      
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      this.getTicketStore(this.standActions.idResource);
    },
    async closeAndNextTicket() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      await this.closeNextStore(ids);
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      this.getTicketStore(this.standActions.idResource);
    },
    async cancelAndNextTicket() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      await this.cancelnextStore(ids);
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      this.getTicketStore(this.standActions.idResource);
    },

    async assignTicketLeft(queue) {
      console.log(queue.queue, this.standActions.idResource);

      let ids = [queue.queue, this.standActions.idResource];
      await this.assignTicketStoreLeft(ids);
      if (this.actualTicket.length != 0) {
        this.showCreate = false;
      }
      this.getTicketStore(this.standActions.idResource);

      // this.quitFirst = false;
      // this.showCreate =false;
    },
    restartQueueLeft(queue) {
      let ids = [queue.queue, this.standActions.idResource];
      this.restartQueueStore(ids);
      this.getTicketStore(this.standActions.idResource);
    },
  },

  async created() {

  },
};
</script>

<style scoped>
h5 {
  font-size: 12px;
  font-weight: 300;
  text-align: initial;
}

h3 {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: #aeaeae;
}
</style>


// WEBPACK FOOTER //
// src/views/desktop/QueueStandTurn.vue